import React, { ReactNode } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Regions } from '../../hooks/useConfiguration';

export const SupportedDevices: React.FC<{
  region: Regions;
}> = ({ region }) => {
  const { t: tRegion } = useTranslation(region);
  const { t } = useTranslation();

  switch (region) {
    case 'us':
      return (
        <>
          <h2>{t('about.supportedDevices.title')}</h2>
          <p>{tRegion('about.supportedDevices.lm150.title')}</p>
          <ul style={{ listStyle: 'disc inside' }}>
            <li>{tRegion('about.supportedDevices.lm150.item1')}</li>
          </ul>
          <hr />
        </>
      );
    case 'eu':
      const devices = {
        p2_8w: {
          title: (
            <Trans
              t={tRegion}
              i18nKey={'about.supportedDevices.type'}
              values={{ deviceType: tRegion('about.supportedDevices.devices.p2_8w.deviceType') }}
            />
          ),
          headers: [
            tRegion('about.supportedDevices.table.headers.device'),
            tRegion('about.supportedDevices.table.headers.integratedModem'),
            <Trans
              t={tRegion}
              i18nKey='about.supportedDevices.table.headers.externalModem'
              components={{ br: <br /> }}
              values={{ modemType: tRegion('about.supportedDevices.devices.p2_8w.modemType') }}
            />,
            tRegion('about.supportedDevices.table.headers.viaAPP'),
            tRegion('about.supportedDevices.table.headers.viaSD'),
          ],
          rows: [
            [tRegion('about.supportedDevices.devices.p2_8w.item1'), true, true, true, true],
            [tRegion('about.supportedDevices.devices.p2_8w.item2'), true, true, true, true],
            [tRegion('about.supportedDevices.devices.p2_8w.item3'), false, true, true, true],
            [tRegion('about.supportedDevices.devices.p2_8w.item4'), false, true, true, true],
            [tRegion('about.supportedDevices.devices.p2_8w.item5'), false, true, false, true],
            [tRegion('about.supportedDevices.devices.p2_8w.item6'), false, true, false, true],
          ],
        },
        p3: {
          title: (
            <Trans
              t={tRegion}
              i18nKey={'about.supportedDevices.type'}
              values={{ deviceType: tRegion('about.supportedDevices.devices.p3.deviceType') }}
            />
          ),
          headers: [
            tRegion('about.supportedDevices.table.headers.device'),
            tRegion('about.supportedDevices.table.headers.integratedModem'),
            <Trans
              t={tRegion}
              i18nKey='about.supportedDevices.table.headers.externalModem'
              components={{ br: <br /> }}
              values={{ modemType: tRegion('about.supportedDevices.devices.p3.modemType') }}
            />,
            tRegion('about.supportedDevices.table.headers.viaAPP'),
            tRegion('about.supportedDevices.table.headers.viaSD'),
          ],
          rows: [
            [tRegion('about.supportedDevices.devices.p3.item1'), false, true, false, true],
            [tRegion('about.supportedDevices.devices.p3.item2'), false, true, false, true],
            [tRegion('about.supportedDevices.devices.p3.item3'), false, true, false, true],
            [tRegion('about.supportedDevices.devices.p3.item4'), false, true, false, true],
            [tRegion('about.supportedDevices.devices.p3.item5'), false, true, false, true],
            [tRegion('about.supportedDevices.devices.p3.item6'), false, true, false, true],
            [tRegion('about.supportedDevices.devices.p3.item7'), false, true, false, true],
            [tRegion('about.supportedDevices.devices.p3.item8'), false, true, false, true],
            [tRegion('about.supportedDevices.devices.p3.item9'), false, true, false, true],
          ],
        },
        p3_2: {
          title: (
            <Trans
              t={tRegion}
              i18nKey={'about.supportedDevices.type'}
              values={{ deviceType: tRegion('about.supportedDevices.devices.p3_2.deviceType') }}
            />
          ),
          headers: [
            tRegion('about.supportedDevices.table.headers.device'),
            tRegion('about.supportedDevices.table.headers.integratedModem'),
            <Trans
              t={tRegion}
              i18nKey='about.supportedDevices.table.headers.externalModem'
              components={{ br: <br /> }}
              values={{ modemType: tRegion('about.supportedDevices.devices.p3_2.modemType') }}
            />,
            tRegion('about.supportedDevices.table.headers.viaAPP'),
            tRegion('about.supportedDevices.table.headers.viaSD'),
          ],
          rows: [
            [tRegion('about.supportedDevices.devices.p3_2.item1'), false, true, false, false],
            [tRegion('about.supportedDevices.devices.p3_2.item2'), false, true, false, false],
            [tRegion('about.supportedDevices.devices.p3_2.item3'), false, true, false, false],
            [tRegion('about.supportedDevices.devices.p3_2.item4'), false, true, false, false],
            [tRegion('about.supportedDevices.devices.p3_2.item5'), false, true, false, false],
            [tRegion('about.supportedDevices.devices.p3_2.item6'), false, true, false, false],
            [tRegion('about.supportedDevices.devices.p3_2.item7'), false, true, false, false],
          ],
        },
        p3_4: {
          title: (
            <Trans
              t={tRegion}
              i18nKey={'about.supportedDevices.type'}
              values={{ deviceType: tRegion('about.supportedDevices.devices.p3_4.deviceType') }}
            />
          ),
          headers: [
            tRegion('about.supportedDevices.table.headers.device'),
            tRegion('about.supportedDevices.table.headers.integratedModem'),
            <Trans
              t={tRegion}
              i18nKey='about.supportedDevices.table.headers.externalModem'
              components={{ br: <br /> }}
              values={{ modemType: tRegion('about.supportedDevices.devices.p3_4.modemType') }}
            />,
            tRegion('about.supportedDevices.table.headers.viaAPP'),
            tRegion('about.supportedDevices.table.headers.viaSD'),
          ],
          rows: [
            [tRegion('about.supportedDevices.devices.p3_4.item1'), false, true, false, false],
            [tRegion('about.supportedDevices.devices.p3_4.item2'), false, true, false, false],
            [tRegion('about.supportedDevices.devices.p3_4.item3'), false, true, false, false],
          ],
        },
        p5: {
          title: (
            <Trans
              t={tRegion}
              i18nKey={'about.supportedDevices.type'}
              values={{ deviceType: tRegion('about.supportedDevices.devices.p5.deviceType') }}
            />
          ),
          headers: [
            tRegion('about.supportedDevices.table.headers.device'),
            tRegion('about.supportedDevices.table.headers.integratedModem'),
            <Trans
              t={tRegion}
              i18nKey='about.supportedDevices.table.headers.externalModem'
              components={{ br: <br /> }}
              values={{ modemType: tRegion('about.supportedDevices.devices.p5.modemType') }}
            />,
            tRegion('about.supportedDevices.table.headers.viaAPP'),
            tRegion('about.supportedDevices.table.headers.viaUSBStick'),
          ],
          rows: [
            [tRegion('about.supportedDevices.devices.p5.item1'), false, true, false, true],
            [tRegion('about.supportedDevices.devices.p5.item2'), false, true, false, true],
            [tRegion('about.supportedDevices.devices.p5.item3'), false, true, false, true],
            [tRegion('about.supportedDevices.devices.p5.item4'), false, true, false, true],
            [tRegion('about.supportedDevices.devices.p5.item5'), false, true, false, true],
          ],
        },
      };

      return (
        <>
          <h2>{t('about.supportedDevices.title')}</h2>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
            {Object.values(devices).map((device, index) => (
              <SupportedDevicesTable key={index} {...device} />
            ))}
          </div>

          <hr />
        </>
      );
  }
};

const SupportedDevicesTable: React.FC<{ title: ReactNode; headers: ReactNode[]; rows: (ReactNode | boolean)[][] }> = ({
  title,
  headers,
  rows,
}) => {
  return (
    <div>
      <div className='about__devices-supported__type-header'>{title}</div>

      <table className='about__devices-supported__devices-table'>
        <thead>
          <tr>
            {headers.map((header, index) => (
              <th key={index}>{header}</th>
            ))}
          </tr>
        </thead>

        <tbody>
          {rows.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {row.map((cell, cellIndex) => (
                <td key={cellIndex}>{typeof cell === 'boolean' ? <SupportIcon value={cell} /> : cell}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const SupportIcon: React.FC<{ value: boolean }> = ({ value }) =>
  value ? (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <path d='M3 8L7 11L13 4' stroke='#80B000' strokeWidth='2' />
    </svg>
  ) : (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <path d='M4 12L12 4' stroke='#A6A6A6' strokeWidth='2' />
      <path d='M12 12L4 4' stroke='#A6A6A6' strokeWidth='2' />
    </svg>
  );
